import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
  },
  variantDefault: {
    maxWidth: theme.dimensions.xxl,
    width: '100%',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  variantDefaultXXS: {
    maxWidth: theme.dimensions.xxs,
  },
  variantDefaultXS: {
    maxWidth: theme.dimensions.xs,
  },
  variantDefaultSM: {
    maxWidth: theme.dimensions.sm,
  },
  variantDefaultMD: {
    maxWidth: theme.dimensions.md,
  },
  variantDefaultLG: {
    maxWidth: theme.dimensions.lg,
  },
  variantDefaultXL: {
    maxWidth: theme.dimensions.xl,
  },
  variantDefaultXXL: {
    maxWidth: theme.dimensions.xxl,
  },
  variantDefaultXXXL: {
    maxWidth: theme.dimensions.xxxl,
  },
  variantFull: {
    maxWidth: '100vw',
  },
});

function Layout({
  children, classes, className, variant, width, test,
}) {
  return (
    <div
      className={classNames(
        classes.root,
        {
          [classes.variantDefault]: variant === 'default',
          [classes.variantDefaultXXS]: width === 'xxs' && variant === 'default',
          [classes.variantDefaultXS]: width === 'xs' && variant === 'default',
          [classes.variantDefaultSM]: width === 'sm' && variant === 'default',
          [classes.variantDefaultMD]: width === 'md' && variant === 'default',
          [classes.variantDefaultLG]: width === 'lg' && variant === 'default',
          [classes.variantDefaultXL]: width === 'xl' && variant === 'default',
          [classes.variantDefaultXXL]: width === 'xxl' && variant === 'default',
          [classes.variantDefaultXXXL]: width === 'xxxl' && variant === 'default',
          [classes.variantFull]: variant === 'full',
        },
        className,
      )}
      test={test}
    >
      {children}
    </div>
  );
}

Layout.defaultProps = {
  className: '',
  test: null,
  width: 'xxl',
};

Layout.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  width: PropTypes.oneOf([
    'xxs',
    'xs',
    'sm',
    'md',
    'lg',
    'xl',
    'xxl',
    'xxxl',
  ]),
  variant: PropTypes.oneOf(['full', 'default']).isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  test: PropTypes.string,
};

export default withStyles(styles)(Layout);
